export default "__VITE_ASSET__C4USAcX0__"